import { render, staticRenderFns } from "./UsersSearchRecommend.vue?vue&type=template&id=0f7c416a&scoped=true"
import script from "./UsersSearchRecommend.vue?vue&type=script&lang=js"
export * from "./UsersSearchRecommend.vue?vue&type=script&lang=js"
import style0 from "./UsersSearchRecommend.vue?vue&type=style&index=0&id=0f7c416a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7c416a",
  null
  
)

export default component.exports